import api from '@/services/api';

export default {
  async getAll(propertyId, isPropertyGroup, year, accountingBasisId) {
    try {
      let response = await api.get(`Budgets?propertyOrGroupId=${propertyId}&isPropertyGroup=${isPropertyGroup || false}&year=${year}&accountingBasisId=${accountingBasisId}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async getExistingBudgetYears() {
    try {
      let response = await api.get('Budgets/YearDropdown');
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async getExistingBudgetAccountingBases() {
    try {
      let response = await api.get('Budgets/AccountingBasisDropdown');
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async getBudgetSettings(budgetIterationId) {
    try {
      let response = await api.get(`Budgets/${budgetIterationId}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (ex) {
      console.error(ex);
      return null;
    }
  },
  async getBudgetSettingsByPropertyIds(propertyIds, year, useOption) {
    try {
      let requestBody = {
        propertyIds: propertyIds,
        year: year,
        useOption: useOption
      };
      let response = await api.post(`Budgets/SettingsSummary`, requestBody);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (ex) {
      console.error(ex);
      return null;
    }
  },
  async getSettingsSummaryExportFile(propertySettingsFilter, propertySettingsData) {
    try {
      let requestBody = {
        propertySettingsFilter: propertySettingsFilter,
        propertySettingsData: propertySettingsData
      };

      let response = await api({
        url: `Budgets/GetSettingsSummaryExportFile`,
        method: 'POST',
        data: requestBody,
        responseType: 'blob'
      });

      if (response && response.status == 200 && response.data) {
        return response;
      }
      return null;
    } catch (ex) {
      console.error(ex);
      return null;
    }
  },
  async getBudgetDescription(budgetIterationId) {
    try {
      let response = await api.get(`Budgets/${budgetIterationId}/Description`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return '';
    } catch (ex) {
      console.error(ex);
      return '';
    }
  },
  async updateBudgetDescription(budgetIterationId, newDescription) {
    try {
      let requestBody = {
        budgetIterationId: budgetIterationId,
        description: newDescription
      }
      let response = await api.post(`Budgets/${budgetIterationId}/Description`, requestBody);
      if (response && response.status == 200 && response.data) {
        return true;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
  async createBudget(budgetSettings) {
    try {
      let requestBody = {
        propertyId: (budgetSettings.property && budgetSettings.property.value),
        templateId: (budgetSettings.template && budgetSettings.template.value),
        year: budgetSettings.year,
        startMonth: budgetSettings.startMonth,
        accountingBasisId: budgetSettings.accountingBasisId,
        description: budgetSettings.description,

        estimateFutureHistoricalsOption: budgetSettings.estimateFutureHistoricalsOption,
        estimateFutureHistoricalOptionMonthOption: budgetSettings.estimateFutureHistoricalOptionMonthOption,
        estimateFutureHistoricalsOccupancyWorkbooksOption: budgetSettings.estimateFutureHistoricalsOccupancyWorkbooksOption,
        increaseOverExistingRentAmount: budgetSettings.increaseOverExistingRentAmount,
        increaseOverExistingRentDenomination: budgetSettings.increaseOverExistingRentDenomination,
        capRentIncreaseAtMarketRent: budgetSettings.capRentIncreaseAtMarketRent,
        discountMarketRentPercentage: budgetSettings.discountMarketRentPercentage,
        newLeaseCalculationOption: budgetSettings.newLeaseCalculationOption,
        renewalPricingCalculationOption: budgetSettings.renewalPricingCalculationOption,
        newRecurringConcessionMarketRentPercentage: budgetSettings.newRecurringConcessionMarketRentPercentage,
        renewalRecurringConcessionMarketRentPercentage: budgetSettings.renewalRecurringConcessionMarketRentPercentage,
        newRecurringConcessionTransactionCategoryId: (budgetSettings.newRecurringConcessionTransactionCategoryId && budgetSettings.newRecurringConcessionTransactionCategoryId.value),
        renewalRecurringConcessionTransactionCategoryId: (budgetSettings.renewalRecurringConcessionTransactionCategoryId && budgetSettings.renewalRecurringConcessionTransactionCategoryId.value),
        otherConcessionTransactionCategories: (budgetSettings.otherConcessionTransactionCategories && budgetSettings.otherConcessionTransactionCategories.map((cat) => { return cat.value })) || [],
        badDebtOption: budgetSettings.badDebtOption,
        badDebtGLAccount: (budgetSettings.badDebtGLAccount && budgetSettings.badDebtGLAccount.value),
        badDebtGLPercentage: budgetSettings.badDebtGLPercentage,
        BadDebtTransactionCategoryId: (budgetSettings.badDebtTransactionCategoryId && budgetSettings.badDebtTransactionCategoryId.value),

        approvalWorkflowId: budgetSettings.approvalWorkflowId || null,
        beginningVacancies: budgetSettings.beginningVacancies,
        projectionLastUpdatedDate: budgetSettings.projectionLastUpdatedDate,
        cloneWorkingRowsFromBudgetIterationId: budgetSettings.cloneWorkingRowsFromBudgetIterationId
      };
      let response = await api.post('Budgets', requestBody);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (ex) {
      console.error(ex);
      return null;
    }
  },
  async createBudgetIteration(budgetId, budgetIterationId, budgetIterationTypeId) {
    try {
      let requestBody = {
        budgetId: budgetId,
        cloneFromBudgetIterationId: budgetIterationId,
        budgetIterationTypeId: budgetIterationTypeId || 1
      };
      let response = await api.post('Budgets/CreateIteration', requestBody);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (ex) {
      console.error(ex);
      return null;
    }
  },
  async updateBudgetSettings(budgetIterationId, budgetSettings) {
    try {
      let requestBody = {
        budgetIterationId: budgetIterationId,

        templateId: (budgetSettings.template && budgetSettings.template.value),
        year: budgetSettings.year,
        startMonth: budgetSettings.startMonth,
        accountingBasisId: budgetSettings.accountingBasisId,
        description: budgetSettings.description,
        template: budgetSettings.template,

        estimateFutureHistoricalsOption: budgetSettings.estimateFutureHistoricalsOption,
        estimateFutureHistoricalOptionMonthOption: budgetSettings.estimateFutureHistoricalOptionMonthOption,
        estimateFutureHistoricalsOccupancyWorkbooksOption: budgetSettings.estimateFutureHistoricalsOccupancyWorkbooksOption,
        increaseOverExistingRentAmount: budgetSettings.increaseOverExistingRentAmount,
        increaseOverExistingRentDenomination: budgetSettings.increaseOverExistingRentDenomination,
        capRentIncreaseAtMarketRent: budgetSettings.capRentIncreaseAtMarketRent,
        discountMarketRentPercentage: budgetSettings.discountMarketRentPercentage,
        newLeaseCalculationOption: budgetSettings.newLeaseCalculationOption,
        renewalPricingCalculationOption: budgetSettings.renewalPricingCalculationOption,
        newRecurringConcessionMarketRentPercentage: budgetSettings.newRecurringConcessionMarketRentPercentage,
        renewalRecurringConcessionMarketRentPercentage: budgetSettings.renewalRecurringConcessionMarketRentPercentage,
        newRecurringConcessionTransactionCategoryId: (budgetSettings.newRecurringConcessionTransactionCategoryId && budgetSettings.newRecurringConcessionTransactionCategoryId.value),
        renewalRecurringConcessionTransactionCategoryId: (budgetSettings.renewalRecurringConcessionTransactionCategoryId && budgetSettings.renewalRecurringConcessionTransactionCategoryId.value),
        otherConcessionTransactionCategories: (budgetSettings.otherConcessionTransactionCategories && budgetSettings.otherConcessionTransactionCategories.map((cat) => { return cat.value })),
        badDebtOption: budgetSettings.badDebtOption,
        badDebtGLAccount: budgetSettings.badDebtGLAccount && budgetSettings.badDebtGLAccount.value,
        badDebtGLPercentage: budgetSettings.badDebtGLPercentage,
        BadDebtTransactionCategoryId: budgetSettings.badDebtTransactionCategoryId && budgetSettings.badDebtTransactionCategoryId.value,

        approvalWorkflowId: budgetSettings.approvalWorkflowId || null,
        beginningVacancies: budgetSettings.beginningVacancies,
        projectionLastUpdatedDate: budgetSettings.projectionLastUpdatedDate,

        lastModifiedTimestamp: budgetSettings.lastModifiedTimestamp
      };
      let response = await api.put('Budgets', requestBody);
      if (response && response.status == 200 && response.data) {
        return true;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
  async updateIsArchived(budgetIterationId, isArchived, lastModifiedTimestamp) {
    try {
      let requestBody = {
        budgetIterationId: budgetIterationId,
        newIsArchived: isArchived,
        lastModifiedTimestamp: lastModifiedTimestamp
      };
      let response = await api.put('Budgets/UpdateIsArchived', requestBody);
      if (response && response.status == 200 && response.data) {
        return true;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
  async getStatusHistory(budgetIterationId) {
    try {
      let response = await api.get(`Budgets/${budgetIterationId}/History`);
      if (response && response.status == 200 && response.data && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async getBudgetGroups(budgetIterationId) {
    try {
      let response = await api.get(`Budgets/${budgetIterationId}/Groups`);
      if (response && response.status == 200 && response.data && response.data.data) {
        return response.data.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async getBudgetGroupTotals(budgetIterationId, groupId) {
    try {
      let response = await api.get(`Budgets/${budgetIterationId}/Groups/${groupId}/Totals`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async checkIfBudgetExists(propertyId, year, accountingBasisId) {
    try {
      let response = await api.get(`Budgets/CheckIfBudgetExists?propertyId=${propertyId}&year=${year}&accountingBasisId=${accountingBasisId}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async getBudgetIterations(budgetId) {
    try {
      let response = await api.get(`Budgets/Iterations?budgetId=${budgetId}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async importExistingBudget(formData, propertyId, year, accountingBasisId, budgetIterationId) {
    try {
      let uploadURL = `Budgets/ImportExistingBudget`;

      let requestBody = {
        PropertyId: propertyId,
        Year: year,
        AccountingBasisId: accountingBasisId,
        budgetIterationId: budgetIterationId
      };

      formData.append('requestJSONString', JSON.stringify(requestBody));

      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };

      let response = await api.post(uploadURL,
        formData, config);

      if (response && response.status == 200) {
        return { Success: true, Data: "Import Succeeded" };
      }
      return [];
    } catch (ex) {
      console.error(ex);
      if (ex.response.data) {
        return { Success: false, Data: ex.response.data };
      }
      return { Success: false, Data: "Request failed. Please reload and try again." };
    }
  },
  async importAndCreateBudget(formData, propertyId, year, accountingBasisId, startMonth) {
    try {
      let uploadURL = `Budgets/ImportAndCreateBudget`;

      let requestBody = {
        propertyId: propertyId,
        year: year,
        accountingBasisId: accountingBasisId,
        startMonth: startMonth
      };

      formData.append('requestJSONString', JSON.stringify(requestBody));

      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };

      let response = await api.post(uploadURL,
        formData, config);

      if (response && response.status == 200) {
        return { Success: true, Data: "Import Succeeded" };
      }
      return [];
    } catch (ex) {
      console.error(ex);
      if (ex.response.data) {
        return { Success: false, Data: ex.response.data };
      }
      return { Success: false, Data: "Request failed. Please reload and try again." };
    }
  },
  async getBudgetBasicExportURL(budgetIterationId) {
    try {
      let response = await api.post(`Budgets/${budgetIterationId}/BasicExport`);
      if (response && response.status == 200 && response.data) {
        var downloadUrl = process.env.VUE_APP_API_URL + `/Documents/${response.data}`;
        return { Success: true, Data: downloadUrl };
      }
      return { Success: false, Data: response.data };
    } catch (ex) {
      console.error(ex);
      if (ex.response.data) {
        return { Success: false, Data: ex.response.data };
      }
      return { Success: false, Data: "Request failed. Please reload and try again." };
    }
  },
  async getBudgetExpandedExportURL(options) {
    try {
      let requestBody = {
        budgetIterationId: options.budgetIterationId,
        includeCalculations: options.includeCalculations,
        includeAssumptions: options.includeAssumptions,
        includePerUnit: options.includePerUnit,
        includePerSqft: options.includePerSqft,
        includeBalanceSheetAccounts: options.includeBalanceSheetAccounts,
        includeZeroRows: options.zeroRowsDisplayed,
        includeWorkingRows: options.workingRowsDisplayed,
        includeWorksheets: options.includeWorksheets,
        includeSettings: options.includeSettings
      };
      let response = await api.post(`Budgets/${options.budgetIterationId}/ExpandedExport`, requestBody);
      if (response && response.status == 200 && response.data) {
        var downloadUrl = process.env.VUE_APP_API_URL + `/Documents/${response.data}`;
        return { Success: true, Data: downloadUrl };
      }
      return { Success: false, Data: response.data };
    } catch (ex) {
      console.error(ex);
      if (ex.response.data) {
        return { Success: false, Data: ex.response.data };
      }
      return { Success: false, Data: "Request failed. Please reload and try again." };
    }
  },
  async publishBudget(budgetIterationId, lastModifiedTimestamp) {
    try {
      let requestBody = {
        lastModifiedTimestamp: lastModifiedTimestamp
      }

      let response = await api.post(`Budgets/${budgetIterationId}/Publish`, requestBody);
      if (response && response.status == 200) {
        return true;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
  async reforecastBudget(budgetIterationId, throughMonthOption, populateWithOption, deactivateMarketRentAndOccupancy, lastModifiedTimestamp) {
    try {
      let requestBody = {
        throughMonthOption: throughMonthOption,
        populateWithOption: populateWithOption,
        deactivateMarketRentAndOccupancy: deactivateMarketRentAndOccupancy,
        lastModifiedTimestamp: lastModifiedTimestamp
      }

      let response = await api.post(`Budgets/${budgetIterationId}/Reforecast`, requestBody);
      if (response && response.status == 200) {
        return true;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },

  async checkForBulkBudgetCreation(bulkBudgetSettings) {
    try {
      let requestBody = {
        templateId: (bulkBudgetSettings.templateId && bulkBudgetSettings.templateId.value),
        year: bulkBudgetSettings.year,
        startMonth: bulkBudgetSettings.startMonth,
        accountingBasisId: bulkBudgetSettings.accountingBasisId,
        settingsTemplateId: (bulkBudgetSettings.settingsTemplateId && bulkBudgetSettings.settingsTemplateId.value),
        propsOrGroups: (bulkBudgetSettings.propsOrGroups && bulkBudgetSettings.propsOrGroups.map((cat) => { return { propertyOrGroupId: cat.value, isPropertyGroup: cat.isPropertyGroup } })) || []
      };
      let response = await api.post('Budgets/CheckForBulkBudgetsCreation', requestBody);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (ex) {
      console.error(ex);
      return null;
    }
  },
  async createBulkBudgets(bulkBudgetSettings) {
    try {
      let requestBody = {
        templateId: (bulkBudgetSettings.templateId && bulkBudgetSettings.templateId.value),
        year: bulkBudgetSettings.year,
        startMonth: bulkBudgetSettings.startMonth,
        accountingBasisId: bulkBudgetSettings.accountingBasisId,
        settingsTemplateId: (bulkBudgetSettings.settingsTemplateId && bulkBudgetSettings.settingsTemplateId.value),
        propsOrGroups: (bulkBudgetSettings.propsOrGroups && bulkBudgetSettings.propsOrGroups.map((cat) => { return { propertyOrGroupId: cat.value, isPropertyGroup: cat.isPropertyGroup } })) || [],
        bulkCreateErrors: (bulkBudgetSettings.bulkCreateErrors && bulkBudgetSettings.bulkCreateErrors.map((cat) => { return { propertyId: cat.propertyId, error: cat.error, errorId: cat.errorId, propertyAbbreviation: cat.propertyAbbreviation, timesDisplayed: cat.timesDisplayed } })) || [],
        cloneWorkingRowsFromBudgetIterationId: bulkBudgetSettings.cloneWorkingRowsFromBudgetIterationId
      };
      let response = await api.post('Budgets/CreateBulkBudgets', requestBody);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (ex) {
      console.error(ex);
      return null;
    }
  },
  async getExistingBulkCreationYears() {
    try {
      let response = await api.get('Budgets/BulkCreationsYearDropdown');
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async getAllBulkCreations(year) {
    try {
      let response = await api.get(`Budgets/BulkCreations?year=${year}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async changeStartMonth(budgetIterationId, budgetSettings) {
    try {
      let requestBody = {
        budgetIterationId: budgetIterationId,
        budgetId: budgetSettings.budgetId,
        templateId: (budgetSettings.template && budgetSettings.template.value),
        year: budgetSettings.year,
        startMonth: budgetSettings.startMonth,
        accountingBasisId: budgetSettings.accountingBasisId,
        description: budgetSettings.description,
        template: budgetSettings.template,

        estimateFutureHistoricalsOption: budgetSettings.estimateFutureHistoricalsOption,
        estimateFutureHistoricalOptionMonthOption: budgetSettings.estimateFutureHistoricalOptionMonthOption,
        estimateFutureHistoricalsOccupancyWorkbooksOption: budgetSettings.estimateFutureHistoricalsOccupancyWorkbooksOption,
        increaseOverExistingRentAmount: budgetSettings.increaseOverExistingRentAmount,
        increaseOverExistingRentDenomination: budgetSettings.increaseOverExistingRentDenomination,
        capRentIncreaseAtMarketRent: budgetSettings.capRentIncreaseAtMarketRent,
        discountMarketRentPercentage: budgetSettings.discountMarketRentPercentage,
        newLeaseCalculationOption: budgetSettings.newLeaseCalculationOption,
        renewalPricingCalculationOption: budgetSettings.renewalPricingCalculationOption,
        newRecurringConcessionMarketRentPercentage: budgetSettings.newRecurringConcessionMarketRentPercentage,
        renewalRecurringConcessionMarketRentPercentage: budgetSettings.renewalRecurringConcessionMarketRentPercentage,
        newRecurringConcessionTransactionCategoryId: (budgetSettings.newRecurringConcessionTransactionCategoryId && budgetSettings.newRecurringConcessionTransactionCategoryId.value),
        renewalRecurringConcessionTransactionCategoryId: (budgetSettings.renewalRecurringConcessionTransactionCategoryId && budgetSettings.renewalRecurringConcessionTransactionCategoryId.value),
        otherConcessionTransactionCategories: (budgetSettings.otherConcessionTransactionCategories && budgetSettings.otherConcessionTransactionCategories.map((cat) => { return cat.value })) || [],
        badDebtOption: budgetSettings.badDebtOption,
        badDebtGLAccount: budgetSettings.badDebtGLAccount && budgetSettings.badDebtGLAccount.value,
        badDebtGLPercentage: budgetSettings.badDebtGLPercentage,
        BadDebtTransactionCategoryId: budgetSettings.badDebtTransactionCategoryId && budgetSettings.badDebtTransactionCategoryId.value,

        approvalWorkflowId: budgetSettings.approvalWorkflowId || null,
        beginningVacancies: budgetSettings.beginningVacancies,
        projectionLastUpdatedDate: budgetSettings.projectionLastUpdatedDate,

        lastModifiedTimestamp: budgetSettings.lastModifiedTimestamp
      };
      let response = await api.put('Budgets/ChangeStartMonth', requestBody);
      if (response && response.status == 200 && response.data) {
        return true;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
  async delete(budgetIterationId) {
    try {
      let response = await api.delete(`Budgets/${budgetIterationId}`);
      if (response && response.status == 200) {
        return true;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  }
}

